import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from '../app/views/home/home.component';
import { SingleViewComponent } from './views/single-view/single-view.component';
import { PresentationViewComponent } from './views/presentation-view/presentation-view.component';

export const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full', title: "Easy Anlass", data: { title: "Willkommen" } },
  {
    path: 'p',
    children: [
      { path: '**', component: PresentationViewComponent }
    ],
    title: "Easy Anlass"
  },
  { path: '**', component: SingleViewComponent, title: "Easy Anlass" },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class DynamicUiRoutingModule { }
